import Coverage from '@/modules/common/common/models/MID/Coverage'
import { PetRaterAdditionalCoverage } from './PetRaterAdditionalCoverate'

export class PetRater {
  name: string
  additionalCoverages: PetRaterAdditionalCoverage[]
  coverages: Coverage[]

  constructor(data: any = {}) {
    this.name = data.name
    this.additionalCoverages = data.additionalCoverages?.map(
      (ac: any) => new PetRaterAdditionalCoverage(ac) ?? []
    )
    this.coverages = data.coverages?.map((c: any) => new Coverage(c)) ?? []
  }
}
